import { create } from "zustand";
import { FILTERS } from "../consts";

interface AttributeTabState {
  resetAttribute: () => void;
  selectedTab: string;
  isError: boolean;
  setSelectedTab: (filter: string) => void;
  setIsError: (value: boolean) => void;
}

export const useAttributeTabStore = create<AttributeTabState>((set) => ({
  isError: false,
  resetAttribute: () => set({ selectedTab: FILTERS.ALL }),
  selectedTab: FILTERS.ALL,
  setIsError: (value:boolean) => set({ isError: value }),
  setSelectedTab: (tab: string) => set({ selectedTab: tab })
}));
